import React from 'react'
import _ from 'lodash'
import QCView from './QCView'
import { withRouter } from 'react-router'

class QCViewWrapper extends React.Component {
  componentDidMount () {
    const { getControlMaterials } = this.props
    getControlMaterials('TEST_STRIP')
  }

  componentDidUpdate (prevProps) {
    const { params, qcResults, getQc } = this.props
    if ((!qcResults || !qcResults.id) && params.qcId && params.qcId !== 'create') {
      getQc(params.qcId)
    }
  }

  render () {
    const { qcResults, controlMaterials } = this.props

    // eslint-disable-next-line max-len
    // We are following this pattern: https://reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#recommendation-fully-uncontrolled-component-with-a-key
    return (
      <QCView
        key={`qc-${_.size(qcResults)} controlMaterials-${_.size(controlMaterials)}`}
        {...this.props}
      />
    )
  }
}

export default withRouter(QCViewWrapper)



// WEBPACK FOOTER //
// ./src/routes/QC/components/QCViewWrapper.jsx